export const FREQUENCY_TYPES = ['daily', 'weekly'];
export const CHANGE_TYPES = ['new only', 'new or updated'];